<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>

  <div v-if="mounted" id="city-transactions">

    <div class="vx-row">

      <div class="vx-col md:w-1/3 w-full mb-base">

        <vx-card title="Générer un rapport">

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>
                    A partir du
                </span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <datepicker v-model="dateFrom" placeholder="Select Date"></datepicker>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>
                  Jusqu'au
                </span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <datepicker v-model="dateTo" placeholder="Select Date"></datepicker>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>

                </span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-button :disabled="dateFrom >= dateTo" color="success" type="filled" @click="loadReportData">Générer</vs-button>
            </div>
          </div>

          <span>{{ status }}</span>
          <div class="mt-5">
            <vs-progress :height="12" :percent="100.0 * progressCurrent / (!progressTotal ? 1 : progressTotal)" color="success"></vs-progress>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-slider-component/theme/antd.css'
// eslint-disable-next-line no-unused-vars
import Datepicker from 'vuejs-datepicker'
import XLSX from 'xlsx'
import moment from 'moment'
import firebase from 'firebase'

const CommonLib = require('@/lib/Common')

export default {
  components: {
    Datepicker,
  },
  data ()
  {
    return {
      progressTotal:   1,
      progressCurrent: 0,
      mounted:         false,
      status:          '',

      dateFrom: new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000)),
      dateTo:   new Date(),
    }
  },
  computed: {
    activeUserInfo ()
    {
      return this.$store.state.AppActiveUser
    },
    cityConfig ()
    {
      return this.$store.state.cityConfig
    },
  },
  methods:  {
    loadClients (clientsIds)
    {
      this.status = 'Chargement des clients'

      return CommonLib.processBatch(Array.from(new Set(clientsIds)),
        clientID => {
          return firebase
            .firestore()
            .collection('clients')
            .doc(clientID)
            .get()
            .then(result => {
              const data = result.data()
              data.id    = result.id
              if (!result.exists)
              {
                return { id: data.id, firstName: '[[ CLient introuvable ]]' }
              }

              data.nbVisitsYear = data.yearlyVisits[moment().format('YYYY')] || 0

              return data
            })
        },
        (curIndex, length, result) => {
          this.progressTotal   = length
          this.progressCurrent = curIndex

          this.status = `Chargement des clients (${  this.progressCurrent  } / ${  this.progressTotal  } )`

        })

      // we now have a promises array and we want to wait for it

    },
    loadReportData ()
    {
      this.status = 'Chargement des transactions'

      this.dateFrom.setHours(0, 0, 0, 0)
      this.dateTo.setHours(23, 59, 59, 999)

      const transactions = []
      firebase
        .firestore()
        .collection('transactions')
        .where('cityID', '==', this.cityConfig.id)
        .where('createdAt', '>=', this.dateFrom)
        .where('createdAt', '<=', this.dateTo)
        .orderBy('createdAt', 'asc')
        .get()
        .then(snapshot => {

          const clientsIds = []
          snapshot.forEach(doc => {

            const transactionData = doc.data()
            transactionData.id    = doc.id

            clientsIds.push(transactionData.clientID)
            transactions.push(transactionData)
          })

          this.loadClients(clientsIds).then(clients => {
            this.progressCurrent = this.progressTotal
            this.generateReport(transactions, clients)

          })

        })

    },

    generateReport (transactions, clients)
    {
      const new_workbook = XLSX.utils.book_new()
      const reportName   = `${moment(this.dateFrom).format('YYYY-MM-DD')}_to_${moment(this.dateTo).format('YYYY-MM-DD')}`

      const worksheet = this.generateReportTransactions(transactions, clients)
      XLSX.utils.book_append_sheet(new_workbook, worksheet, 'Transactions')

      const worksheet2 = this.generateReportTotals(transactions, clients)
      XLSX.utils.book_append_sheet(new_workbook, worksheet2, 'Totaux')

      XLSX.writeFile(new_workbook, `INEO-Rapport-${reportName}.xlsx`)

      this.status = ''

    },

    generateReportTransactions (transactions, clients)
    {
      this.status = 'Création du rapport des transactions'

      const materialsNames = this.cityConfig.quotaMaterials.map(material => material.name)

      const columns = [
        'createdAt',
        'nbVisitsYear',
        'firstName',
        'lastName',
        'addressNo',
        'addressStreet',
        'addressApp',
        'postalCode',
        'city',
        'notes',
        'clientID',
        ...materialsNames
      ]

      const rows = []
      transactions.forEach(transaction => {

        const row = {}

        row.createdAt = moment(transaction.createdAt.toDate()).format('YYYY-MM-DD HH:mm:ss')
        // eslint-disable-next-line prefer-template
        row.clientID  = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/city/client/' + transaction.clientID
        row.notes     = transaction.notes || ''

        const client = clients.find(item => item.id === transaction.clientID)

        if (client)
        {
          row.nbVisitsYear  = client.nbVisitsYear
          row.addressNo     = client.addressNo
          row.addressStreet = client.addressStreet
          row.addressApp    = client.addressApp
          row.postalCode    = client.postalCode
          row.city          = client.city
          row.firstName     = client.firstName
          row.lastName      = client.lastName
        }

        transaction.materials.forEach(material => {
          row[material.name] = material.value
        })

        rows.push(row)
      })

      return this.rowsToWorkSheet(columns, rows)
    },

    generateReportTotals (transactions, clients)
    {
      this.status = 'Création du rapport des transactions'

      const materialsNames = this.cityConfig.quotaMaterials.map(material => material.name)

      // eslint-disable-next-line no-unused-vars
      const materialsQuotas = []

      this.cityConfig.quotaMaterials.forEach(material => {
        materialsQuotas[material.name] = material.quota
      })

      const columns = [
        'firstName',
        'lastName',
        'addressNo',
        'addressStreet',
        'addressApp',
        'postalCode',
        'city',

        'sum',
        'quotaSum',

        'nbTransactions',
        'nbQuotaTransactions',
        
        ...materialsNames,
        'clientID',
      ]

      const rows = []
      transactions.forEach(transaction => {

        if (rows[transaction.clientID] === undefined)
        {

          const client = clients.find(item => item.id === transaction.clientID)

          const clientDetails = {}

          if (client)
          {
            clientDetails.nbVisitsYear  = client.nbVisitsYear
            clientDetails.addressNo     = client.addressNo
            clientDetails.addressStreet = client.addressStreet
            clientDetails.addressApp    = client.addressApp
            clientDetails.postalCode    = client.postalCode
            clientDetails.city          = client.city
            clientDetails.firstName     = client.firstName
            clientDetails.lastName      = client.lastName
          }

          rows[transaction.clientID] = {
            clientID: `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}/city/client/${transaction.clientID}`,
            ...clientDetails,
            nbTransactions:      0,
            nbQuotaTransactions: 0,
            sum:                 0,
            quotaSum:            0
          }

          materialsNames.forEach(name => {
            rows[transaction.clientID][name] = 0
          })

        }

        transaction.materials.forEach(material => {

          rows[transaction.clientID][material.name] += material.value
          rows[transaction.clientID].sum += material.value

          rows[transaction.clientID].nbTransactions++

          if (materialsQuotas[material.name])
          {
            rows[transaction.clientID].quotaSum += material.value
            rows[transaction.clientID].nbQuotaTransactions++
          }

        })
      })

      const data = Object.values(rows)

      data.sort((a, b) => b.quotaSum -  a.quotaSum)

      return this.rowsToWorkSheet(columns, data)
    },
    rowsToWorkSheet (columns, rows)
    {
      const arr    = []
      const wscols = []

      const row = []
      columns.forEach(colName => {
        row.push(colName)
        wscols.push({ wch: 20 })
      })
      arr.push(row)

      rows.forEach(obj => {
        const row = []

        columns.forEach(colName => {
          row.push(obj[colName] || '')
        })

        arr.push(row)
      })

      const worksheet = XLSX.utils.aoa_to_sheet(arr)

      worksheet['!cols'] = wscols

      return worksheet
    },

    init ()
    {
      if (!this.cityConfig || !this.cityConfig.id)
      {
        return
      }

      this.mounted = true
    },
  },
  watch:    {
    '$store.state.cityConfig' ()
    {
      this.init()
    },
    cityConfig ()
    {
      console.log('Report: Updated city info')
      this.init()
    },

  },
  mounted ()
  {
    console.log('Report: monuted')

    this.init()
  }
}
</script>

<style lang="scss">
.vs-dialog {
  max-width: 80% !important;
}
</style>
